import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AddPhotoComponent } from "./add-photo/add-photo.component";
import { AddPrescriptionComponent } from "./add-prescription/add-prescription.component";
import { AddressInfoComponent } from "./address-info/address-info.component";
import { ContactInfoComponent } from "./contact-info/contact-info.component";
import { SetupCompleteComponent } from "./setup-complete/setup-complete.component";
import { SignUpComponent } from "./sign-up.component";

const routes: Routes = [
    {
      path: '',
      data: {
        title: 'Sign Up'
      },
      children: [  
        {
          path: '',
          component: SignUpComponent,
          data: {
            title: 'Home'
          }
        },
        {
            path: 'contact-info',
            component: ContactInfoComponent,
            data: {
              title: 'Contact Info'
            }
          },
          {
            path: 'address-info',
            component: AddressInfoComponent,
            data: {
              title: 'Address Info'
            }
          },
          {
            path: 'add-prescription',
            component: AddPrescriptionComponent,
            data: {
              title: 'Add Prescription'
            }
          },
          {
            path: 'add-photo',
            component: AddPhotoComponent,
            data: {
              title: 'Add Photo'
            }
          },
          {
            path: 'setup-complete',
            component: SetupCompleteComponent,
            data: {
              title: 'SetupComplete'
            }
          },
      ]
    }
  ];
  
  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class SignUpRoutingModule { }
  